import React, { useContext, useEffect, useState } from 'react'
import styles from "./schedulePopUp.module.css";
import { AuthContext } from '../../../contextAPI';
import { CancelAppointmentById, GetAllAppointments } from '../../../utils/appointments';
import { notify } from '../../toast';
import phone_icon from "../../../assets/phone_icon.png"
import time_icon from "../../../assets/time_icon.png"
import date_icon from "../../../assets/date_icon.png"

const SchedulePopUp = (props) => {

    const [AppointmentsArray, setAppointmentsArray] = useState([])
    const [cancelAppointment, setCancelAppointment] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const Auth = useContext(AuthContext);
    const token = Auth.isLoggedIn ? Auth.authenticatedUser.token.access_token : null

    let UniqueDates = AppointmentsArray.map(a => a.appointment_date).filter(function (v, i, self) {
        return i == self.indexOf(v);
    });


    useEffect(()=>{

        const getAppointments = async()=>{

            try {
                const response = await GetAllAppointments(token)

                if(!response.status || !response.data)throw new Error(response.message)

                setAppointmentsArray(response.data)
                setIsLoading(false)

            } catch (error) {
                setIsLoading(false)
                return notify(error.message, "error");
            }
        }

        getAppointments()
    },[cancelAppointment])



    const onDeleteHandler = async(id)=> {
        if(!id)return notify("Užsakymas nerastas","warning")
            
        try {
            const response = await CancelAppointmentById({
                id:id
            },token)

            if(!response.status || !response.data)throw new Error(response.message)

            setAppointmentsArray(response.data)

        } catch (error) {
            return notify(error.message, "error");
        }

        setCancelAppointment(!cancelAppointment)
    }


    return (
        <div className={styles.container}>
            <h1 className={styles.header}>Rezervacijos</h1>
            <ul className={styles.list}>
            {   
                (AppointmentsArray && UniqueDates) && (AppointmentsArray.length > 0 && UniqueDates.length > 0) ?
                UniqueDates.map(date => {

                    const timesForTheDate = AppointmentsArray.filter(obj => obj.appointment_date === date);

                    return <div className={styles.dates_wrapper}>
                        <div className={styles.date}>
                            <h2 style={{ color: "#64766A" }}>{date}</h2>
                            <img src={date_icon} alt='' />
                        </div>
                        <ul className={styles.list}>
                            {
                                timesForTheDate.map((obj, index) => {

                                    return <li key={index}>
                                        <div className={styles.obj_wrapper}>
                                            <img src={time_icon} alt='' />
                                            <h2>{obj.appointment_time}</h2>
                                        </div>
                                        <div className={styles.obj_wrapper}>
                                            <img src={phone_icon} alt='' />
                                            <h2>{obj.clients_phone}</h2>
                                        </div>
                                        <div onClick={()=>{onDeleteHandler(obj._id)}} style={{ backgroundColor: "#FF9696", cursor:"pointer" }} className={styles.obj_wrapper}>
                                            <h2 style={{ color:"white" }}>Atšaukti</h2>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                })
                :
                <>
                    {
                        !isLoading
                        && <h2 style={{ textAlign:"center", color:"#94A7AE" }}>Šiuo metu neturite jokių rezervacijų</h2>
                    }
                </>
            }
            </ul>
        </div>
    )
}

export default SchedulePopUp